module.exports = __webpack_public_path__ + "static/media/pgmolIcon.2804a7e9.png";